import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../img/logo.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "left",
  style: {"background":"#f0f2f6"}
}
const _hoisted_3 = { class: "Side" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = { class: "child" }
const _hoisted_7 = { class: "upload" }
const _hoisted_8 = { class: "el-upload__tip" }
const _hoisted_9 = { class: "chat-msg.system" }
const _hoisted_10 = { class: "chat-msg.system" }
const _hoisted_11 = { class: "chat-input" }

import { ref, watch, nextTick} from 'vue'
import axios from 'axios'
import { UploadFilled ,Search,Tickets, Loading} from '@element-plus/icons-vue'
import type { UploadProps, UploadUserFile, UploadInstance} from 'element-plus'
import {ElMessage, ElMessageBox, ElNotification} from 'element-plus'

/* -------------------- 数据类型  --------------------  */
/*
interface tabledata {
    cluster : string,
    markers : string,
    celltype: string,
    basis   : string
}
*/
/*
interface Message {
    id     : number;
    content: string;
    avatar : string; // URL
    side   : 'left' | 'right';
    time   : string; // HH:MM
  }
*/
interface Message{
  role   :string;                 // 角色
  content:string;                 // 信息
}
/* ----------------------- 变量 ---------------------- */
const example        = "IGHM,IGHD,CD79A,IL4R,MS4A1,CXCR4,BTG1,TCL1A,CD79B,YBX3\nGZMH,CD4,FGFBP2,ITGB1,GZMA,CST7,GNLY,B2M,IL32,NKG7\nTCF7,CD4,CCR7,IL7R,FHIT,LEF1,MAL,NOSIP,LDHB,PIK3IP1\nIL7R,TMSB10,CD4,ITGB1,LTB,TRAC,AQP3,LDHB,IL32,MAL\nIL7R,CCL5,FYB1,GZMK,IL32,GZMA,KLRB1,TRAC,LTB,AQP3"
const uploadurl      = "https://aicelltype.jinlab.online/upload"

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const tissue         = ref("")
const markergenes    = ref("")
const uploadnum      = ref(0)
const tableData      = ref([])
const loading        = ref(false)
const tabshow        = ref(false)
const chatroom       = ref(false)
const messageData    = ref<Record<string,Array<Message>>>({})    // 所有对话记录
const msg            = ref<Array<Message>>([])                   // 窗口消息
const selectindex    = ref(0)
const prompt         = ref({
                          "markers" : "" ,
                          "celltype": "" ,
                          "tissue"  : "" 
                        })
const newMessage     = ref('');                                  // 窗口输入的消息
// 上传文件如果不用额外参数的话其实也可以把样本组织类型作为文件名上传
const info           = ref({
                            "tissue"     : "",
                            "temperature": 0.1
                          })
const chatDIV        = ref(null)
watch(()=>tissue.value,(newValue)=>{info.value.tissue = newValue})
/* ----------------- 文件上传前的操作 ----------------- */
const beforeupload: UploadProps['beforeUpload'] = (UploadRawFile)=>{
  // 文件大小校验
  if(UploadRawFile.size > 500 * 1024){
    alert(info.value.tissue)
    ElMessage.error(`file ${UploadRawFile.name} exceeds the maximum size of 100kb`)
    return false
  }
}

/* ----------------- 文件上传成功后的操作 ----------------- */
const onsuccess: UploadProps['onSuccess'] = (response, uploadFile, uploadFiles)=>{
  // 提示上传成功并且展示表格
  tableData.value = response
  tabshow.value   = true
}


/* ----------------- 文件上传失败后的操作 ----------------- */
const onerror: UploadProps['onError'] = (err, uploadFile, UploadFiles)=>{
  ElMessage.error(`file ${uploadFile.name} uoload failed, error message: ${err.name},${err.message}`)
}


const onremove: UploadProps['onRemove'] = (uploadFile, uploadFiles)=>{
  uploadnum.value = uploadFiles.length
}

const onchange: UploadProps['onChange'] = (uploadFile, uploadFiles)=>{
  uploadnum.value = uploadFiles.length
}
/* ----------------------- 提交注释 ----------------------- */
const uploadRef = ref<UploadInstance>()
function Annotation(){
  if(tissue.value == ""){
    ElNotification({
      title  : 'Error',
      message: 'Please enter the name of the tissue from which the cells are derived',
      type   : 'error',
    })
    return
  }
  if(uploadnum.value == 0 && markergenes.value == ""){
    ElMessageBox.confirm(
      "No markers gene was filled and no files were uploaded",
      "Error",
      {
        showCancelButton: false,
        confirmButtonText: 'OK',
        type: 'error',
      }
    )
    return
  }
  if(markergenes.value != ""){
    axios.post('/api_v2',
        {
        tissue      : tissue.value,
        markergenes : markergenes.value,
        temperature : 0.1

        }).then(function(response){
          tableData.value = response.data
          tabshow.value   = true
        }).catch(function(error){
          console.log(error)
        })
    return
  }
  if(uploadnum.value != 0){
    uploadRef.value!.submit()
  }
}

/* ----------------- 以选中的行继续循环提问 ----------------- */
function Connect_AI(idx){
  if(selectindex.value != idx){
    selectindex.value = idx
    newMessage.value  = ""
  }
  if(`${idx}` in messageData.value){
    msg.value = messageData.value[`${idx}`]
  }else{
    msg.value = []
  }
  prompt.value   = {
                    "celltype" : tableData.value[idx]['celltype'],
                    "markers"  : tableData.value[idx]['markers'],
                    "tissue"   : tissue.value
                  }
  chatroom.value = true
}
/* ----------------- 拼接字符串成tsv格式，blob ----------------- */


/* ------------------------------------------------------------ */
function sendMessage() {
  if(!newMessage.value.trim()){
    return
  }
  msg.value.push({'role':'user', 'content':newMessage.value})
  newMessage.value = ""
  loading.value    = true
  axios.post('/ai',{
              "prompt":prompt.value,
              "info"  :msg.value
              }).then(function(response){
                loading.value = false
                msg.value.push(response.data)
                if(chatDIV.value){
                  nextTick(()=>{
                    chatDIV.value.scrollTop = chatDIV.value.scrollHeight
                  })
                }
              }).catch(function(error){
                ElMessageBox.confirm(
                      `${error}`,
                      "Error",
                      {
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        type: 'error',
                      }
                    )
                console.log(error)
                loading.value = false
              })
}

/* ------------------------------------------------------------ */
function ChatBeforeClose(done:()=>void){
  messageData.value[`${selectindex.value}`] = msg.value
  done()
}
/* ------------------------------------------------------------ */
function DownloadSample(){
  axios.get('/download',{
            responseType: 'blob'
        }).then(function(response){
          const disposition = response.headers['content-disposition']
          let filename = 'cluster_top10.csv'
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        }).catch(function(error){
          console.log(error)
        })
}

return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!
  const _component_font = _resolveComponent("font")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_center, null, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              style: {"width":"80%","height":"auto"},
              src: _imports_0
            }, null, -1)
          ]))]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createStaticVNode("<label><h3>Project Introduction</h3></label><hr><label><h5>Welcome to AICelltype</h5></label><label style=\"font-size:0.9rem;line-height:180%;\"><strong>AICelltype</strong> is an intelligent cell type annotation tool powered by the cutting-edge large language model, <strong> Claude 3.5 Sonnet</strong>. After a comprehensive benchmark of 79 leading models, we selected the top performer to bring you: </label><ul style=\"font-size:0.9rem;margin:0,0,0,0;line-height:180%;\"><li><strong>Accurate &amp; Efficient</strong>: Achieves up to 70% exact match rate, significantly outperforming traditional methods.</li><li><strong>Free &amp; User‑Friendly</strong>: Offers a convenient online annotation platform and an R package for seamless integration with standard workflows like Seurat.</li><li><strong>Robust &amp; Powerful</strong>: Demonstrates excellent performance in rare cell identification, cross‑dataset generalization, and supports both single‑cell and spatial transcriptomics data.AICelltype aims to simplify your research and empower new breakthroughs in single‑cell studies.<strong>Start your cell annotation journey now!</strong></li></ul><hr><label> We welcome feedback and suggestions. Please feel free to report issues or request features via our GitHub issues page.<a href=\"https://github.com/mooerccx/AICelltype\">GitHub repository</a></label><br><br><br>", 10))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _createVNode(_component_font, {
          color: "#2087D6",
          size: "6"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("AICelltype Online Cell Type Annotation Platform", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"font-size":"small"} }, "Please enter the name of the tissue from which the cells are derived:", -1)),
        _createVNode(_component_el_input, {
          modelValue: tissue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tissue).value = $event)),
          size: "large",
          style: {"margin-top":"10pt"},
          clearable: "",
          placeholder: "PBMC"
        }, null, 8, ["modelValue"]),
        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _cache[15] || (_cache[15] = _createElementVNode("span", { style: {"font-size":"small"} }, "Please enter the list of marker genes to be annotated, one cluster per line.", -1)),
        _createVNode(_component_el_input, {
          modelValue: markergenes.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((markergenes).value = $event)),
          rows: 6,
          type: "textarea",
          placeholder: example
        }, null, 8, ["modelValue"]),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
        _cache[18] || (_cache[18] = _createElementVNode("span", { style: {"font-size":"small"} }, "You can also upload the top 10 gene list obtained from Seurat analysis.", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            class: "upload-demo",
            drag: "",
            "before-upload": beforeupload,
            "on-success": onsuccess,
            "on-error": onerror,
            "on-remove": onremove,
            "on-change": onchange,
            "auto-upload": false,
            limit: 1,
            action: uploadurl,
            data: info.value,
            multiple: ""
          }, {
            tip: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _cache[8] || (_cache[8] = _createTextVNode("csv/tsv files with a size less than 500kb ", -1)),
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: DownloadSample
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Download sample file", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadFilled))
                ]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "el-upload__text" }, [
                _createTextVNode("Drop file here or "),
                _createElementVNode("em", null, "click to upload")
              ], -1))
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: Annotation
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Annotation", -1)
          ]))]),
          _: 1
        }, 8, ["icon"]),
        _withDirectives(_createVNode(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"},
          height: "350pt",
          stripe: "",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "cluster",
              label: "cluster",
              "min-width": "75"
            }),
            _createVNode(_component_el_table_column, {
              prop: "markers",
              label: "markers",
              "min-width": "300"
            }),
            _createVNode(_component_el_table_column, {
              prop: "celltype",
              label: "celltype",
              "min-width": "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "basis",
              label: "basis",
              "min-width": "400"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "continue",
              "min-width": "90"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (Connect_AI(scope.$index)), ["prevent"])
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Connect_AI ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]), [
          [_vShow, tabshow.value]
        ])
      ]),
      _createVNode(_component_el_dialog, {
        class: "chat",
        modelValue: chatroom.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((chatroom).value = $event)),
        title: "AICelltype",
        width: "600",
        draggable: "true",
        modal: false,
        "before-close": ChatBeforeClose,
        center: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "chat-message",
            ref_key: "chatDIV",
            ref: chatDIV
          }, [
            _createElementVNode("div", _hoisted_9, [
              _cache[19] || (_cache[19] = _createTextVNode(" The cluster with marker gene ", -1)),
              _createVNode(_component_el_text, {
                class: "mx-1",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(prompt.value.markers), 1)
                ]),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createTextVNode(" in your ", -1)),
              _createVNode(_component_el_text, {
                class: "mx-1",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tissue.value), 1)
                ]),
                _: 1
              }),
              _cache[21] || (_cache[21] = _createTextVNode(" sample has been annotated as ", -1)),
              _createVNode(_component_el_text, {
                class: "mx-1",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(prompt.value.celltype), 1)
                ]),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createTextVNode(". For more detailed annotation basis, please continue to enter the query ", -1))
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.value, (itmes) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['chat-msg', itmes.role]),
                key: itmes.content
              }, _toDisplayString(itmes.content), 3))
            }), 128)),
            _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
              [_directive_loading, loading.value],
              [_vShow, _unref(Loading)]
            ])
          ], 512),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_input, {
              class: "chat-input-msg",
              modelValue: newMessage.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newMessage).value = $event)),
              placeholder: "Send a message……",
              maxlength: "200",
              type: "textarea",
              resize: "none",
              clearable: "",
              onKeyup: _withKeys(sendMessage, ["enter"]),
              autosize: { minRows: 1, maxRows: 2 }
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "chat-input-button",
              type: "primary",
              icon: _unref(Tickets),
              onClick: sendMessage,
              disabled: !newMessage.value.trim()
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("Send", -1)
              ]))]),
              _: 1
            }, 8, ["icon", "disabled"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})